<template>
  <v-container grid-list-md class="brand-typography">
      <v-layout v-if="publicDataLoaded">
          <transition name="fade" appear>
              <v-layout row wrap>
                  <v-flex xs12 class="mt-5" >
                      <v-layout row wrap>
                          <v-flex xs12>
                              <v-layout row xs12  wrap align-center>
                                  <span style="font-size: 32px" class="hidden-sm-and-down">Un Stock Sûr Pour Toujours</span>
                                  <span style="font-size: 22px" class="hidden-sm-and-up">Un Stock Sûr Pour Toujours</span>
                                  <v-btn icon medium class="primary previous0 hidden-sm-and-down" dark><v-icon medium>keyboard_arrow_left</v-icon></v-btn>
                                  <v-btn icon medium class="primary next0 hidden-sm-and-down" dark><v-icon medium>keyboard_arrow_right</v-icon></v-btn>
                              </v-layout>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mt-4">
                          <v-flex>
                              <slick
                                      ref="slick"
                                      :options="slickOptions"
                              >
                                  <v-flex xs12 v-for="(product, index) in products" :key="index">
                                      <v-card style="border-radius: 10px">
                                          <v-img height="150px"
                                                 :src="product.productImg"
                                                 :lazy-src="product.productImg"
                                                 aspect-ratio="1"
                                          >
                                          </v-img>
                                          <v-card-actions>
                                              <v-layout row wrap class="pr-3 pl-3 pt-2 pb-2">
                                                  <v-flex xs12 class="pa-1" style="line-height: 30px">
                                                      <div><b>{{product.productName}}</b></div>
                                                      <div class="primary--text">{{product.productProducer}}</div>
                                                      <div class="">{{product.soldAs}} ({{product.soldAsOf}})</div>
                                                  </v-flex>
                                                  <v-flex xs12 class="pa-2">
                                                      <div><span style="font-size: 20px">{{product.productPrice | currency}}</span></div>

                                                      <v-layout row xs12  wrap align-center class="">
                                                          <v-btn medium block dark class="primary" @click="addToCart(product)"><b>Ajoutez</b> <v-icon small right>shopping_cart</v-icon></v-btn>
                                                          <v-btn icon><v-icon>favorite_outline</v-icon></v-btn>
                                                      </v-layout>
                                                  </v-flex>
                                              </v-layout>
                                          </v-card-actions>
                                      </v-card>
                                  </v-flex>
                              </slick>
                          </v-flex>
                      </v-layout>
                  </v-flex>
                  <v-flex xs12 class="mt-5" >
                      <v-layout row wrap>
                          <v-flex xs12>

                              <v-layout row xs12  wrap align-center>
                                  <span style="font-size: 32px" class="hidden-sm-and-down">Nouveaux produits</span>
                                  <span style="font-size: 22px" class="hidden-sm-and-up">Nouveaux produits</span>
                                  <v-btn icon medium class="primary previous1 hidden-sm-and-down" dark><v-icon medium>keyboard_arrow_left</v-icon></v-btn>
                                  <v-btn icon medium class="primary next1 hidden-sm-and-down" dark><v-icon medium>keyboard_arrow_right</v-icon></v-btn>
                              </v-layout>


                          </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mt-4">
                          <v-flex>
                              <slick
                                      ref="slick"
                                      :options="slickOptions1"
                              >
                                  <v-flex xs12 v-for="(product, index) in nouveauProducts" :key="index">
                                      <v-card style="border-radius: 10px">
                                          <v-img height="150px"
                                                 :src="product.productImg"
                                                 :lazy-src="product.productImg"
                                                 aspect-ratio="1"
                                          >
                                          </v-img>
                                          <v-card-actions>
                                              <v-layout row wrap class="pr-3 pl-3 pt-2 pb-2">
                                                  <v-flex xs12 class="pa-1" style="line-height: 30px">
                                                      <div><b>{{product.productName}}</b></div>
                                                      <div class="primary--text">{{product.productProducer}}</div>
                                                      <div class="">{{product.soldAs}} ({{product.soldAsOf}})</div>
                                                  </v-flex>
                                                  <v-flex xs12 class="pa-2">
                                                      <div><span style="font-size: 20px">{{product.productPrice | currency}}</span></div>

                                                      <v-layout row xs12  wrap align-center class="">
                                                          <v-btn medium block dark class="primary" @click="addToCart(product)"><b>Ajoutez</b> <v-icon small right>shopping_cart</v-icon></v-btn>
                                                          <v-btn icon><v-icon>favorite_outline</v-icon></v-btn>
                                                      </v-layout>
                                                  </v-flex>
                                              </v-layout>
                                          </v-card-actions>
                                      </v-card>
                                  </v-flex>
                              </slick>
                          </v-flex>
                      </v-layout>
                  </v-flex>
                  <v-flex xs12 class="mt-5" >
                      <v-layout row wrap>
                          <v-flex xs12>
                              <v-layout row wrap>
                                  <v-flex xs12 flexbox class="text-xs-left">
                                      <span style="font-size: 32px" class="hidden-sm-and-down">Explorez notre gamme</span>
                                      <span style="font-size: 22px" class="hidden-sm-and-up">Explorez notre gamme</span>
                                  </v-flex>
                              </v-layout>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                          <v-flex xs12>
                              <v-layout row wrap>
                                  <v-flex xs12 md3 flexbox d-flex class="" v-for="(range, index) in ranges" :key="index" @click="openRange(range.name)">
                                      <v-card style="border-radius: 10px">
                                          <v-img height="150px"  :src="range.photo" :lazy-src="range.photo" aspect-ratio="1">
                                          </v-img>
                                          <v-flex xs12>
                                              <span style="font-size: 18px">{{range.name}}</span>
                                          </v-flex>

                                      </v-card>
                                  </v-flex>
                              </v-layout>
                          </v-flex>
                      </v-layout>
                  </v-flex>
              </v-layout>
          </transition>
      </v-layout>
      <v-layout row wrap v-else>
          <v-container grid-list-md fill-height>
              <v-layout row wrap align-center justify-center>
                  <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
              </v-layout></v-container>
      </v-layout>
  </v-container>
</template>
<script>
 import '../assets/style/vuetify-import.css'
 export default {
   computed: {
     publicDataLoaded () {
       return this.$store.state.publicDataLoaded
     },
     ranges () {
       return this.$store.state.ranges
     },
     nouveauProducts () {
       return this.$store.getters.products
     },
     products () {
       return this.$store.state.products
     }
   },
   metaInfo: {
     title: 'Ligablo Food - Congo',
     titleTemplate: 'Un stock sûr, pour toujours',
     meta: [
       { name: 'application-name', content: 'Ligablo Food' },
       { name: 'description', content: 'A description of the page', id: 'desc' },
       // OpenGraph data (Most widely used)
       {property: 'og:title', content: 'Ligablo Food - Un stock sûr, pour toujours'},
       {property: 'og:site_name', content: 'Ligablo Food'},
       // The list of types is available here: http://ogp.me/#types
       {property: 'og:type', content: 'website'}
     ]
   },
   components: {
     Slick: () => import('vue-slick')
   },
   data () {
     return {
       product: [
         {available: 30, category: 'Charcuterie', discount: '0', productId: '43WNE5e3bvu1vZ9v7vt1', productImg: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/productImages%2F43WNE5e3bvu1vZ9v7vt1..jpg?alt=media&token=434c8faf-a09e-4c9e-841f-d6fbe26461dc', productName: 'Saucisse de goma', productPrice: '18000.00', productPricePerKgL: '18000.00', productProducer: 'Chamoki', qty: 1, soldAs: 'Sachet', soldAsOf: '1Kg', unit: 'Kg'},
         {available: 30, category: 'Charcuterie', discount: '0', productId: '43WNE5e3bvu1vZ9v7vt1', productImg: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/productImages%2F43WNE5e3bvu1vZ9v7vt1..jpg?alt=media&token=434c8faf-a09e-4c9e-841f-d6fbe26461dc', productName: 'Saucisse de goma', productPrice: '18000.00', productPricePerKgL: '18000.00', productProducer: 'Chamoki', qty: 1, soldAs: 'Sachet', soldAsOf: '1Kg', unit: 'Kg'},
         {available: 30, category: 'Charcuterie', discount: '0', productId: '43WNE5e3bvu1vZ9v7vt1', productImg: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/productImages%2F43WNE5e3bvu1vZ9v7vt1..jpg?alt=media&token=434c8faf-a09e-4c9e-841f-d6fbe26461dc', productName: 'Saucisse de goma', productPrice: '18000.00', productPricePerKgL: '18000.00', productProducer: 'Chamoki', qty: 1, soldAs: 'Sachet', soldAsOf: '1Kg', unit: 'Kg'},
         {available: 30, category: 'Charcuterie', discount: '0', productId: '43WNE5e3bvu1vZ9v7vt1', productImg: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/productImages%2F43WNE5e3bvu1vZ9v7vt1..jpg?alt=media&token=434c8faf-a09e-4c9e-841f-d6fbe26461dc', productName: 'Saucisse de goma', productPrice: '18000.00', productPricePerKgL: '18000.00', productProducer: 'Chamoki', qty: 1, soldAs: 'Sachet', soldAsOf: '1Kg', unit: 'Kg'},
         {available: 30, category: 'Charcuterie', discount: '0', productId: '43WNE5e3bvu1vZ9v7vt1', productImg: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/productImages%2F43WNE5e3bvu1vZ9v7vt1..jpg?alt=media&token=434c8faf-a09e-4c9e-841f-d6fbe26461dc', productName: 'Saucisse de goma', productPrice: '18000.00', productPricePerKgL: '18000.00', productProducer: 'Chamoki', qty: 1, soldAs: 'Sachet', soldAsOf: '1Kg', unit: 'Kg'}
       ],
       slickOptions: {
         dots: false,
         infinite: false,
         speed: 500,
         slidesToShow: 4,
         slidesToScroll: 1,
         arrows: true,
         prevArrow: '.previous0',
         nextArrow: '.next0',
         responsive: [
           {
             breakpoint: 1024,
             settings: {
               slidesToShow: 4,
               slidesToScroll: 1,
               infinite: false,
               dots: false,
               arrows: true
             }
           },
           {
             breakpoint: 600,
             settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
               arrows: true,
               dots: false
             }
           },
           {
             breakpoint: 480,
             settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: false
             }
           }
         ]
       },
       slickOptions1: {
         dots: false,
         infinite: false,
         speed: 500,
         slidesToShow: 4,
         slidesToScroll: 1,
         arrows: true,
         prevArrow: '.previous1',
         nextArrow: '.next1',
         responsive: [
           {
             breakpoint: 1024,
             settings: {
               slidesToShow: 4,
               slidesToScroll: 1,
               infinite: false,
               dots: false,
               arrows: true
             }
           },
           {
             breakpoint: 600,
             settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
               arrows: true,
               dots: false
             }
           },
           {
             breakpoint: 480,
             settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
               arrows: true,
               dots: false
             }
           },
           {
             breakpoint: 320,
             settings: {
               slidesToShow: 2,
               slidesToScroll: 2,
               arrows: true,
               dots: false
             }
           }
         ]
       }
     }
   },
   async created () {
   },
   methods: {
     openRange (payload) {
       this.$router.push('/gamme/' + payload)
     },
     addToCart (payload) {
       this.$store.dispatch('ADD_ITEMS', payload)
     },
     next () {
       this.$refs.slick.next()
     },
     prev () {
       this.$refs.slick.prev()
     },
     reInit () {
       // Helpful if you have to deal with v-for to update dynamic lists
       this.$nextTick(() => {
         this.$refs.slick.reSlick()
       })
     }
   }
 }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
.paragraphText{
    font-size: 16px;
}
.productNameTextSize{
    font-size: 18px;
}
@font-face {
    font-family: "Product Sans";
    src: url("/static/fonts/Product_Sans.ttf");
}
.brand-typography {
    font-family: "Product Sans",'Poppins', serif;
}
    @import "../../node_modules/slick-carousel/slick/slick.css";

.lds-grid {
    display: inline-block;
    position: relative;
    width: 100px;
    height: 100px;
}
.lds-grid div {
    position: absolute;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #145900;
    animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
    top: 6px;
    left: 6px;
    animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
    top: 6px;
    left: 26px;
    animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
    top: 6px;
    left: 45px;
    animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
    top: 26px;
    left: 6px;
    animation-delay: -0.8s;
}
.lds-grid div:nth-child(5) {
    top: 26px;
    left: 26px;
    animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
    top: 26px;
    left: 45px;
    animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
    top: 45px;
    left: 6px;
    animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
    top: 45px;
    left: 26px;
    animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
    top: 45px;
    left: 45px;
    animation-delay: -1.6s;
}
@keyframes lds-grid {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
    transition-delay: 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Congo.vue